import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoInclude } from "../../../core/store/dto/dto";

export class NotificationTemplateDto extends AccountObjectDto {
    @DtoInclude
    channel: string;
    @DtoInclude
    title: string;
    @DtoInclude
    subject: string;
    @DtoInclude
    recipients: string;
    @DtoInclude
    content: string;
    @DtoInclude
    reportLayouts: Array<string>;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.dto.ts